import {prefix} from "app/config/routes/pp/_cfg";

export const routePPAccount = {
    'pp.profile': `${prefix}/profile`,
    'pp.account': `${prefix}/account`,
    'pp.settings': `${prefix}/account/settings`,
}